import React, { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Promise from 'bluebird';
import FormField from 'scy/FormField';
import { LoadingButton, ConfirmButton } from 'scy/buttons';
import FacebookBtn from 'shared/components/facebookBtn';
import { Warning } from 'scy/Warning';
import { TextHR } from 'scy/HR';
import { login } from 'components/login/actions';
import { textLeft, linkText } from 'scy/utils.mod.scss';
import { flex, flex1 } from 'scy/flex.mod.scss';
import styles from './styles.mod.scss';

function validateEmail(email) {
  if (!email) return "Email can't be blank";
}

function validatePassword(password) {
  if (!password) return "Password can't be blank";
}

function LoginForm({ initEmail, login, onSuccess, showForgotPassword }) {
  const [errors, setErrors] = useState({});
  const [asyncError, setAsyncError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(initEmail || '');
  const [password, setPassword] = useState('');

  function validateFields() {
    let errors = {};
    errors.email = validateEmail(email) || null;
    errors.password = validatePassword(password) || null;
    setErrors(errors);
    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setAsyncError(null);
    return validateFields()
      .then(() => login({ email, password }))
      .then(user => onSuccess && onSuccess(user))
      .catch(({ message }) => {
        setLoading(false);
        setAsyncError(message);
      });
  }

  return (
    <div className={textLeft}>
      <form onSubmit={handleSubmit}>
        {!!asyncError && <Warning>{asyncError}</Warning>}

        <FormField
          id="user-email"
          name="email"
          labelText="Email"
          inputType="email"
          initialValue={email}
          onChange={setEmail}
          validate={validateEmail}
          error={errors.email}
        />

        <FormField
          id="user-password"
          name="password"
          labelText="Password"
          inputType="password"
          onChange={setPassword}
          validate={validatePassword}
          error={errors.password}
        />

        <div className={styles.forgotLink}>
          <small>
            <a
              className={linkText}
              onClick={showForgotPassword}
              href={showForgotPassword ? null : '/forgot-password'}
            >
              Forgot password?
            </a>
          </small>
        </div>

        <div className={flex}>
          <LoadingButton
            Button={ConfirmButton}
            type="submit"
            className={flex1}
            disabled={loading}
            loading={loading}
          >
            Log In
          </LoadingButton>
        </div>
      </form>

      <TextHR>Or</TextHR>

      <div className={flex}>
        <FacebookBtn
          className={flex1}
          onLogin={onSuccess}
          onComplete={onSuccess}
          onError={({ message }) => setAsyncError(message)}
        />
      </div>
    </div>
  );
}

const ConnectedLoginForm = connect(
  () => ({}),
  { login }
)(LoginForm);

export default ConnectedLoginForm;
